const io = require('socket.io-client');

export class Socket {

    constructor() {

        this.SOCKET_CONNECTION = decodeURIComponent(utils.decodeBase64($('meta[id=_sc]').attr('content') || utils.cookie.get('_sc')));

        utils.cookie.remove('_sc');

        /**
         * Events triggered by the engine
         *
         * 'connected': The client is connected to the server
         * 'disconnected': The client got disconnected to the server
         * 'game_started': The game just started
         * 'game_crash': The game just crashed
         * 'game_starting': The game is going to start in X ms
         *
         * 'player_bet': A player bet
         * 'cashed_out': A player cashed out
         * 'msg': A player sent a message to the chat
         *
         * 'placing_bet':
         * 'bet_placed':
         * 'bet_queued':
         * 'cashing_out':
         * 'cancel_bet':
         *
         * 'lag_change': The engine changed its lag state
         *
         * 'error': Socket io errors
         * 'err': Server errors
         */
    }

    connect(app) {

        let self = this;
        let _t = $('meta[id=_t]').attr('content') || utils.cookie.get('_t');

        utils.cookie.remove('_t');

        self.ws = (typeof io === 'undefined') ? null : io.connect(self.SOCKET_CONNECTION, {transports: ['websocket'], secure: true, forceNew: true, reconnect: true});

        if (self.ws)
        {
            self.ws.on('connect', function() {

                self.offEvents();
                if (_t) {
                    self.ws.emit('join', {token: _t}, self.onJoin.bind(self, app));
                }
            });

            self.ws.on('disconnect', function() {
                console.log('Client disconnected');
                app.state.is_connected = false;
                self.offEvents();
            });

            self.ws.on('error', function(error) {
                console.log('error', error);
                alert(error);
            });

            self.ws.on('refresh', function() {
                console.log('refresh');
                location.reload();
            });
        }

        return this;

    }

    offEvents()
    {
        this.ws.off('channel_message');
        this.ws.off('channel_user_count');
        this.ws.off('game_starting');
        this.ws.off('game_started');
        this.ws.off('game_tick');
        this.ws.off('game_crash');
        this.ws.off('player_bet');
        this.ws.off('cashed_out');
        this.ws.off('message');
        this.ws.off('reconnect_bet');
    }

    onJoin(app, error, response)
    {
        let self = this;
        if (error) {
            if (error == 'Invalid token') {
                if (confirm(app.$trans('alert.Connected to the server. Click OK to refresh'))) {
                    location.reload();
                }
            } else {
                console.error('Error when joining the game...', error);
            }
            return;
        }

        // console.log('join callback : ', response, new Date())


        app.state.channel                       = response.channel;
        app.state.currency                      = response.currency;
        app.state.language                      = app.state.language ? app.state.language : response.language;
        app.state.timezone                      = response.timezone;
        app.state.timezone_offset               = response.timezone_offset;

        app.state.user_class                    = response.user_class;
        app.state.balance                       = response.balance;
        app.state.user_id                       = response.user_id;
        app.state.username                      = response.username;

        app.state.game_state                    = response.game_state;
        app.state.joined                        = response.joined ? _.cloneDeep(response.joined) : [];
        app.state.player_info                   = response.player_info ? _.cloneDeep(response.player_info) : {};
        app.state.game_id                       = response.game_id;
        app.state.max_profit                    = response.max_profit;
        app.state.last_hash                     = response.last_hash;
        app.state.created                       = response.created;
        // app.state.start_time                    = new Date(Date.now() - (response.now - Date.parse(response.created)));
        app.state.start_time                    = new Date(Date.now() - response.elapsed);
        app.state.game_history                  = response.game_history || [];
        app.state.chat_messages                 = response.chat_messages || [];
        app.state.game_play_info.playing_count  = response.playing_count;
        app.state.game_play_info.betting_amount = response.betting_amount;

        app.state.languages                     = response.languages;

        app.state.min_bet                       = response.channel_settings.min_bet;
        app.state.max_bet                       = response.channel_settings.max_bet;
        app.state.is_chat                       = response.channel_settings.is_chat == 1 ? true : false;
        app.state.display_active_controls_tab   = response.channel_settings.display_active_controls_tab;
        app.state.display_masked_username       = response.channel_settings.display_masked_username == 1 ? true : false;
        app.state.display_hash_checker          = response.channel_settings.display_hash_checker == 1 ? true : false;
        app.state.display_play_info             = response.channel_settings.display_play_info == 1 ? true : false;
        app.state.nyan_cat_trigger_ms           = response.channel_settings.nyan_cat_trigger_ms;

        app.state.bet_amount_range = [app.state.min_bet, app.state.min_bet * 5, app.state.min_bet * 10, app.state.min_bet * 50, app.state.min_bet * 100];

        /**
         * Call Ajax Languages
         */
        if (!_.find(app.state.languages, {code: app.state.language})) {
            app.state.language = app.state.languages[0].code;
        }
        app.$store.dispatch('LANGUAGE', app.state.language).then(function(data) {
            app.state.language = data.lang;
            app.state.is_connected = true;
        });

        if (app.state.game_state === 'IN_PROGRESS') {
            app.state.last_game_tick = Date.now();
        }

        // Attach username to each user for sorting proposes
        for (let user_id in app.state.player_info) {
            app.state.player_info[user_id].user_id = user_id;
        }

        app.state.play_state = StateLib.currentlyPlaying(app.state) ? 'playing' : StateLib.isBetting(app.state) ? 'betting' : 'idle';

        /**
         * Event called before starting the game to let the client know when the game is going to start
         * @param {object} info - JSON payload
         * @param {number} info.game_id - The next game id
         * @param {number} info.time_till_start - Time lapse for the next game to begin
         */
        self.ws.on('game_starting', self.onGameStarting.bind(self, app));

        /**
         * Event called at the moment when the game starts
         */
        self.ws.on('game_started', self.onGameStarted.bind(self, app));

        /**
         * Event called each 150ms telling the client the game is still alive
         * @param {number} data - elapsed time
         */
        self.ws.on('game_tick', self.onGameTick.bind(self, app));

        /**
         * Event called at game crash
         * @param {object} data - JSON payload
         * @param {number} data.elapsed - Total game elapsed time
         * @param {number} data.game_crash - Crash payout quantity in percent eg. 200 = 2x. Use this to calculate payout!
         * @param {string} data.hash - Revealed hash of the game
         */
        self.ws.on('game_crash', self.onGameCrash.bind(self, app));

        /**
         * Event called every time a user places a bet
         * the user that placed the bet could be me so we check for that
         * @param {object} resp - JSON payload
         * @param {string} resp.username - The player username
         * @param {number} resp.bet - The player bet in satoshis
         */
        self.ws.on('player_bet', self.onPlayerBet.bind(self, app));

        /**
         * Event called every time the server cash out a user
         * if we call cash out the server is going to call this event
         * with our name.
         * @param {object} resp - JSON payload
         * @param {string} resp.username - The player username
         * @param {number} resp.stopped_at -The percentage at which the user cashed out
         */
        self.ws.on('cashed_out', self.onCashedOut.bind(self, app));

        self.ws.on('message', self.onMessage.bind(self, app));

        self.ws.on('message_update', self.onMessageUpdate.bind(self, app));

        self.ws.on('channel_message', self.onSystemMessage.bind(self, app));

        self.ws.on('channel_user_count', self.onChannelUserCount.bind(self, app));

        self.ws.on('update_channel_settings', self.onUpdateChannelSettings.bind(self, app));

        self.ws.on('update_languages', self.onUpdateLanguages.bind(self, app));

        self.ws.on('player_balance', self.onPlayerBalance.bind(self, app));

        /**
         * Event called on reconnect if the user has an active bet in progress
         */
        self.ws.on('reconnect_bet', self.onReconnectBet.bind(self, app));

        /** Triggered by the server to let users the have to reload the page */
        self.ws.on('update', function() {
            alert('Please refresh your browser! We just pushed a new update to the server!');
        });

        EventBus.$emit('connected');
    }

    onGameStarting(app, buffer)
    {
        let self = this;
        let data = self.arrayBufferToString(buffer);
        // console.log('game_starting', data);

        app.state.player_info = {};
        app.state.joined = [];

        app.state.game_state = 'STARTING';
        app.state.game_id = data.game_id;
        app.state.time_till_start = data.time_till_start;
        app.state.start_time = new Date(Date.now() + data.time_till_start);
        app.state.max_profit = data.max_profit;

        if (app.state.next_bet_amount) {
            self.doBet(app.state, app.state.next_bet_amount, app.state.next_auto_cash_out, function(error) {
                if(error) {
                    console.log('Response from placing a bet: ', error);
                }
            });
        }

        app.state.game_play_info.playing_count = 0;
        app.state.game_play_info.betting_amount = 0;

        EventBus.$emit('game_starting');
    }

    onGameStarted(app, buffer)
    {
        let self = this;
        let data = self.arrayBufferToString(buffer);
        let bets = data.bets;
        // console.log('game_started', bets);

        app.state.joined = [];
        app.state.game_state = 'IN_PROGRESS';
        app.state.start_time = Date.now();
        app.state.last_game_tick = app.state.start_time;
        app.state.placing_bet = false;
        app.state.time_till_start = null;

        app.state.current_bet_amount = null;
        app.state.next_bet_amount = null;
        app.state.next_auto_cash_out = null;

        // Create the player info object with bet and username
        // If you are in the bets rest your bet from your balance
        Object.keys(bets).forEach(function(user_id) {
            if (app.state.user_id == user_id) {
                app.state.play_state = 'playing';
                app.state.balance -= bets[user_id].bet;
            }
            app.state.player_info[user_id] = {game_id: bets[user_id].game_id, bet: bets[user_id].bet, user_id: user_id, username: bets[user_id].username};
        });

        EventBus.$emit('game_started');
    }

    onGameTick(app, buffer)
    {
        let self = this;
        let data = self.arrayBufferToString(buffer);
        // console.log('game_tick', data);

        app.state.last_game_tick = Date.now();

        if (app.state.lag === true) {
            app.state.lag = false;
            EventBus.$emit('lag_change');
        }

        /** Correct the time of startTime every gameTick **/
        let current_latency_start_time = app.state.last_game_tick - data.elapsed;
        if (app.state.start_time > current_latency_start_time) {
            app.state.start_time = current_latency_start_time;
        }
        if (app.state.tick_timer) {
            clearTimeout(app.state.tick_timer);
        }

        app.state.tick_timer = setTimeout(self.checkForLag.bind(self, app), AppConstants.Engine.STOP_PREDICTING_LAPSE);

        //Check for animation triggers
        if(data.elapsed > app.state.nyan_cat_trigger_ms && !self.nyan) {
            app.state.nyan = true;
            EventBus.$emit('nyan_cat_animation');
        }

        EventBus.$emit('game_tick');
    }

    onGameCrash(app, buffer)
    {
        let self = this;
        let data = self.arrayBufferToString(buffer);
        // console.log('game_crash data', data);
        let player = app.state.player_info[app.state.user_id];
        // console.log('game_crash player', player);

        if (app.state.tick_timer) {
            clearTimeout(app.state.tick_timer);
        }

        app.state.last_hash = data.hash;

        let game_info = {
            created: app.state.created,
            ended: true,
            game_crash: data.game_crash,
            game_id: app.state.game_id,
            hash: data.hash,
            player_info: {},
        };

        // Add the current game info to the game history and if the game history is larger than 40 remove one element
        if (app.state.game_history && app.state.game_history.length >= 30) {
            app.state.game_history.pop();
        }
        app.state.game_history.unshift(game_info);

        for (let i = 0; i < app.state.game_history.length; i++) {
            if (player) {
                if (app.state.game_history[i].game_id == player.game_id) {
                    app.state.game_history[i].player_info = app.state.player_info;
                    break;
                }
            }
        }

        app.state.game_state = 'ENDED';
        app.state.cashing_out = false;
        app.state.lag = false;

        // Clear Animation trigger flags
        app.state.nyan = false;

        if (!app.state.next_bet_amount) {
            app.state.play_state = 'idle';
        }

        EventBus.$emit('game_crash');
    }

    onPlayerBet(app, buffer)
    {
        let self = this;
        let data = self.arrayBufferToString(buffer);
        // console.log('player_bet', data)

        if (app.state.user_id === data.user_id) {
            app.state.play_state = 'betting';
            app.state.current_bet_amount = app.state.next_bet_amount;
            app.state.placing_bet = false;
            app.state.next_bet_amount = null;
            app.state.next_auto_cash_out = null;
        }

        app.state.joined.splice(data.index, 0, {user_id: data.user_id, username: data.username});

        if (utils.inArray(['STARTING', 'STARTED'], app.state.game_state)) {
            app.state.game_play_info.playing_count = data.playing_count;
            app.state.game_play_info.betting_amount = data.betting_amount;
        }

        EventBus.$emit('player_bet', data);
    }

    onCashedOut(app, buffer)
    {
        let self = this;
        let response = self.arrayBufferToString(buffer);
        // console.log('cashed_out', response, app.state.player_info)

        // Add the cashout percentage of each user at cash out
        // console.log('app.state.player_info', app.state.player_info)
        if (!app.state.player_info[response.user_id]) {
            return console.warn('Username not found in playerInfo at cashed_out: ', response.username);
        }

        app.state.player_info[response.user_id].stopped_at = response.stopped_at;
        // console.log('cashed_out app.state.player_info', app.state.player_info)
        // console.log('cashed_out user_id', app.state.user_id, response.user_id)

        if (app.state.user_id === response.user_id) {
            app.state.play_state = 'idle';
            app.state.cashing_out = false;
            app.state.balance += app.state.player_info[response.user_id].bet * response.stopped_at / 100;
            app.state.balance = utils.toFixed(app.state.balance);
        }

        EventBus.$emit('cashed_out', response);
    }

    onMessage(app, buffer)
    {
        let self = this;
        let data = self.arrayBufferToString(buffer);
        // console.log('message', data);
        app.state.chat_messages.push(data);
        EventBus.$emit('update_chat_messages');
    }

    onMessageUpdate(app, buffer)
    {
        let self = this;
        let data = self.arrayBufferToString(buffer);
        // console.log('message_update', data);
        app.state.chat_messages = data.chat_messages;
        EventBus.$emit('update_chat_messages');
    }

    onSystemMessage(app, buffer)
    {
        let self = this;
        let data = self.arrayBufferToString(buffer);
        console.log('system_message', data);
    }

    onChannelUserCount(app, buffer)
    {
        let self = this;
        let data = self.arrayBufferToString(buffer);
        // console.log('channel_user_count', data);
        app.state.game_play_info.online = data.online;
    }

    onUpdateChannelSettings(app, buffer)
    {
        let self = this;
        let data = self.arrayBufferToString(buffer);

        app.state.min_bet                       = data.min_bet;
        app.state.max_bet                       = data.max_bet;
        app.state.is_chat                       = data.is_chat == 1 ? true : false;
        app.state.display_active_controls_tab   = data.display_active_controls_tab;
        app.state.display_masked_username       = data.display_masked_username == 1 ? true : false;
        app.state.display_hash_checker          = data.display_hash_checker == 1 ? true : false;
        app.state.display_play_info             = data.display_play_info == 1 ? true : false;
        app.state.nyan_cat_trigger_ms           = data.nyan_cat_trigger_ms;

        app.state.bet_amount_range = [app.state.min_bet, app.state.min_bet * 5, app.state.min_bet * 10, app.state.min_bet * 50, app.state.min_bet * 100];
    }

    onUpdateLanguages(app, buffer)
    {
        let self = this;
        let data = self.arrayBufferToString(buffer);
        app.state.languages = data.languages;
    }

    onPlayerBalance(app, buffer)
    {
        let self = this;
        let data = self.arrayBufferToString(buffer);
        app.state.balance = data.balance;
    }

    onReconnectBet(app, buffer)
    {
        let self = this;
        let data = self.arrayBufferToString(buffer);

        app.state.play_state = 'playing';
        app.state.current_bet_amount = data.bet;

        EventBus.$emit('reconnect_bet', data);
    }

    /**
     * Throw the bet at the server
     *
     * @param bet_amount
     * @param cash_out
     * @param callback
     */
    doBet(state, bet_amount, auto_cash_out, callback) {
        let self = this;
        self.ws.emit('place_bet', bet_amount, auto_cash_out, function(error) {
            if (error) {
                console.warn('place_bet error: ', error);
                if (error !== 'GAME_IN_PROGRESS' && error !== 'ALREADY_PLACED_BET') {
                    alert('There was an error, please reload the window: ' + error);
                }
                if (callback) {
                    callback(error);
                }
                return;
            }

            EventBus.$emit('bet_placed');

            if (callback) {
                callback(null);
            }
        });
        EventBus.$emit('placing_bet');
    }

    send(data)
    {
        let self = this;
        let message = data ? data : $('#message').val();
        self.ws.emit('send', {'message': message});
    }

    checkForLag(app) {
        console.log('Lag ...');
        app.state.lag = true;
        EventBus.$emit('lag_change');
        // console.log('checkForLag', app.state)
    }

    arrayBufferToString(buffer)
    {
        // console.log('buffer', buffer)
        // return JSON.parse(this.binaryToString(String.fromCharCode.apply(null, Array.prototype.slice.apply(new Uint8Array(buffer)))));
        // return JSON.parse(buffer);
        return buffer;
    }

    binaryToString(binary)
    {
        let error;
        try {
            return decodeURIComponent(escape(binary));
        } catch (_error) {
            error = _error;
            if (error instanceof URIError) {
                return binary;
            } else {
                throw error;
            }
        }
    }
}
